<template>
  <div>
    <div v-show="exactRoute">
      <v-card>
        <v-card-title>
          Poptávky
          <v-spacer></v-spacer>
          <vc-date-picker
            v-model="dateFilter"
            is-range
            :columns="2"
            color="blue"
            :popover="{ visibility: 'focus' }">
            <template v-slot="{ dateFilter: inputValue, inputEvents }">
              <div class="d-flex justify-center items-center">
                <v-text-field
                  outlined
                  :value="getLocalizedDate(dateFilter.start)"
                  v-on="inputEvents.start"
                  hide-details
                  readonly
                  placeholder="Od"
                  class="rounded-0 border-right-none"
                  dense
                  style="max-width: 120px"
                />
                <v-text-field
                  class="rounded-0 border-left-none"
                  outlined
                  :value="getLocalizedDate(dateFilter.end)"
                  v-on="inputEvents.end"
                  hide-details
                  dense
                  readonly
                  placeholder="Do"
                  style="max-width: 120px"
                />
              </div>
            </template>
          </vc-date-picker>
          <v-select
            deletable-chips
            small-chips
            dense
            outlined
            hide-selected
            hide-details
            v-model="firmFilter"
            class="rounded-0"
            label="Filtr stavu"
            :items="[{
              text: 'Závazná',
              value: 'true'
            }, {
              text: 'Nezávazná',
              value: 'false'
            }]"
          >
          </v-select>
          <v-form v-model="searchValid" class="d-flex">
            <v-text-field
              v-model.trim="search"
              append-icon="mdi-magnify"
              label="Vyhledat"
              :rules="[validation.required]"
              single-line
              hide-details
              outlined
              ref="searchInput"
              dense
              class="rounded-0"
            ></v-text-field>
            <v-select
              outlined
              class="rounded-0"
              dense
              single-line
              hide-details
              ref="searchTypeInput"
              label="Vyhledat podle"
              :rules="[validation.required]"
              v-model="searchType"
              :items="searchTypes"
            >
            </v-select>
            <v-btn
              color="primary"
              :disabled="!searchValid || runningRequest"
              @click="filterBySearch"
              class="rounded-0"
            >Vyhledat</v-btn>
            <v-btn
              color="error"
              @click="resetSearch()"
              class="rounded-0"
              :disabled="!searchActive || runningRequest"
            >
              Zrušit vyhledávání
            </v-btn>
          </v-form>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="demands"
          class="elevation-1"
          :loading="runningRequest"
          :server-items-length="demandsTotal"
          :options.sync="paginationOptions"
          :footer-props="{'items-per-page-options': [10, 20, 50] }"
        >
          <template v-slot:item.userName="{ item }">
            <!-- {{ item.user.firstName }} {{ item.user.lastName }} -->
              {{ item.user.email }}
          </template>
          <template v-slot:item.firm="{ item }">
            <v-chip
              :color="getColor(item)"
              dark
            >
              {{ getFirmText(item) }}
            </v-chip>
          </template>
          <template v-slot:item.propertyName="{ item }">
            <a :href="`/host/properties/${item.property.id}`" class="table-link">
              {{ item.property.name }}
            </a>
          </template>
          <template v-slot:item.dateFrom="{ item }">
            {{ item.dateFrom | localizedDate }}
          </template>
          <template v-slot:item.dateTo="{ item }">
            {{ item.dateTo | localizedDate }}
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ item.createdAt | localizedDate }}
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- TODO: ???
            <v-icon
              small
              class="mr-2"
              @click="editDialog = true"
            >
              mdi-pencil
            </v-icon> -->
            <v-icon
              small
              @click="deleteDemand(item)"
              class="mr-2"
            >
              mdi-delete
            </v-icon>
            <v-icon
              small
              class="mr-2"
              @click="redirectToDetail(item)"
            >
              mdi-information-variant
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog
        width="450"
        v-model="editDialog">
        <v-card>
          <v-card-title>Změnit stav</v-card-title>
          <v-card-text class="pb-0">
            <v-select
              :items="['Zavazna', 'Nezavazna']"
              label="stav"
              class="rounded-0"
              outlined>
            </v-select>
          </v-card-text>
          <v-card-actions class="d-flex justify-end pt-0">
            <v-btn
              color="primary"
              class="rounded-0">
              Uložit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        width="350"
        v-model="deleteDialog">
        <v-card>
          <v-card-title class="text-center">Opravdu smazat?</v-card-title>
          <v-card-actions class="d-flex justify-center ">
            <v-btn
              width="250"
              color="red"
              class="rounded-0">
              Smazat
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- Start delete dialog -->
    <v-dialog
      width="350"
      v-model="deleteDialog">
      <DeleteResource
        v-if="deleteDialog"
        @delete-success="deleteDemandSuccess"
        @delete-failure="showDeleteFailure"
        resource-type="demands" :resource="demandToDelete" />
    </v-dialog>
    <!-- End delete dialog -->
    <router-view ref="childView"></router-view>
  </div>
</template>

<script>
import demandsOverviewHelpers from '../../mixins/local/demandsOverviewHelpers'
import DeleteResource from '@/components/DeleteResource'
import { mapGetters } from 'vuex'
import archiveHelpers from '@/mixins/local/archiveHelpers'

export default {
  name: 'Demands',
  mixins: [demandsOverviewHelpers, archiveHelpers],
  components: { DeleteResource },
  data () {
    return {
      search: '',
      searchType: null,
      searchValid: true,
      searchTypes: [],
      searchActive: false,
      editDialog: false,
      deleteDialog: false,
      dateFilter: {
        start: null,
        end: null
      },
      firmFilter: null,
      headers: [
        { text: 'Poptávající', align: 'start', value: 'userName' },
        { text: 'Číslo poptávky', value: 'id' },
        { text: 'Typ', value: 'firm' },
        { text: 'Objekt', value: 'propertyName' },
        { text: 'Vytvořeno', value: 'createdAt' },
        { text: 'Od', value: 'dateFrom' },
        { text: 'Do', value: 'dateTo' },
        { text: 'Akce', value: 'actions', sortable: false }
      ],
      runningRequest: false,
      demands: [],
      demandsTotal: 0,
      demandToDelete: {},
      exactRoute: true
    }
  },
  methods: {
    /**
     * Loads demands from backend
     *
     * response: {
         demands: [
           {
             adults: Number,
             children: Number,
             contact_person_city: String,
             contact_person_email: String,
             contact_person_first_name: String,
             contact_person_last_name: String,
             contact_person_phone: String,
             contact_person_street: String,
             contact_person_street_number: String,
             contact_person_zip: String,
             created_at: String,
             date_from: String,
             date_to: String,
             firm: Bool,
             id: Number,
             note: String,
             price: Number,
             rating: null,
             property: {
               id: Number,
               name: String,
               owner: {
                 id: Number,
                 first_name: String,
                 last_name: String
               }
             }
           }
         ],
         total: Number
       }
     *
     * @returns void
     */
    getDemands () {
      this.runningRequest = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.paginationOptions

      this.$http.get(`/hosts/${this.loggedUser.id}/demands`, {
        params: {
          sortBy: sortBy.length ? sortBy[0] : null,
          sortDesc: sortDesc.length ? sortDesc[0] : null,
          search: this.search || null,
          // eslint-disable-next-line no-extra-boolean-cast
          searchType: !!this.searchType ? this.searchType : null,
          from: this.dateFilter.start ? this.dateFilter.start.toISOString().slice(0, 10) : null,
          to: this.dateFilter.end ? this.dateFilter.end.toISOString().slice(0, 10) : null,
          firm: this.firmFilter,
          page,
          itemsPerPage
        }
      })
        .then(res => {
          this.demands = res.data.demands
          this.demandsTotal = +res.data.total
        })
        .finally(() => {
          this.runningRequest = false
        })
    },
    /**
     * Debounced getDemands
     * @return void
     */
    loadDemands () {},
    redirectToDetail (demand) {
      this.$router.push(`/host/demands/${demand.id}`)
    },
    /**
     * Shows dialog for deleting demand
     *
     * @param demand
     * @return void
     */
    deleteDemand (demand) {
      this.demandToDelete = { ...demand }
      this.deleteDialog = true
    },
    deleteDemandSuccess () {
      this.showDeleteSuccess()
      this.getDemands()
    },
    filterBySearch () {
      this.searchActive = true
      this.getDemands()
    },
    resetSearch () {
      this.$refs.searchInput.reset()
      this.$refs.searchTypeInput.reset()
      this.searchActive = false
      this.getDemands()
    }
  },
  watch: {
    firmFilter: {
      handler () {
        this.loadDemands()
      }
    },
    dateFilter: {
      deep: true,
      handler () {
        this.loadDemands()
      }
    },
    '$route.params': {
      deep: true,
      handler (newVal, oldVal) {
        // reload pri prechodu z detailu poptavky na prehled
        if (oldVal.id && !newVal.id) {
          this.getDemands()
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      loggedUser: 'userAuth/user'
    })
  },
  mounted () {
    this.getDemands()
    this.loadDemands = this.debounce(this.getDemands, 2000)
    this.exactRoute = typeof this.$refs.childView === 'undefined'

    this.searchTypes = this.headers.filter(header => {
      const searchables = ['userName', 'hostName', 'propertyName', 'dateFrom', 'dateTo']

      return searchables.includes(header.value)
    })
  },
  updated () {
    this.exactRoute = typeof this.$refs.childView === 'undefined'
  }
}
</script>

<style scoped>

</style>
